var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPinpoint(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 0H10C4.47715 0 0 4.47715 0 10V70C0 75.5229 4.47715 80 10 80H70C75.5229 80 80 75.5229 80 70V10C80 4.47715 75.5229 0 70 0Z",
    fill: "url(#paint0_linear_234_281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3028 52.432C59.297 52.4351 59.2908 52.4383 59.2841 52.4414L51.8455 55.9557C51.9255 56.3675 51.9604 56.7865 51.9492 57.2059C51.9376 57.6397 51.5825 57.9853 51.1488 57.9853C51.1412 57.9853 51.1336 57.9853 51.126 57.9853L40.2393 57.6857C39.7966 57.6737 39.4478 57.3052 39.4599 56.8625C39.4719 56.4198 39.8408 56.071 40.2831 56.0831L50.2902 56.3586C49.9584 54.4192 48.3048 52.9829 46.3382 52.9257L39.7156 52.7437C38.4077 52.7061 37.1252 52.3748 35.963 51.7742L35.2891 51.4254C31.9797 49.7011 27.9918 49.9256 24.897 52.0108L24.6318 61.6449L25.7699 61.0355C26.9008 60.4273 28.2239 60.2824 29.4599 60.6317L40.699 63.7864C42.865 64.23 45.1161 63.9787 47.131 63.0674L62.7018 52.9954C61.8132 52.0859 60.4373 51.8574 59.3028 52.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3179 63.3183L17.7127 48.9844L23.3729 49.1404L22.9781 63.4743L17.3179 63.3183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4979 19.5014V10.8013C41.4979 10.3586 41.1393 10 40.6966 10C40.2539 10 39.8953 10.3586 39.8953 10.8013V19.5014C39.8953 19.9441 40.2539 20.3027 40.6966 20.3027C41.1393 20.3027 41.4979 19.9441 41.4979 19.5014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3666 19.5015V15.3804C48.3666 14.9377 48.0079 14.5791 47.5652 14.5791C47.1225 14.5791 46.7639 14.9377 46.7639 15.3804V19.5015C46.7639 19.9442 47.1225 20.3028 47.5652 20.3028C48.0079 20.3028 48.3666 19.9442 48.3666 19.5015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6295 19.5015V15.3804C34.6295 14.9377 34.2709 14.5791 33.8282 14.5791C33.3855 14.5791 33.0269 14.9377 33.0269 15.3804V19.5015C33.0269 19.9442 33.3855 20.3028 33.8282 20.3028C34.2709 20.3028 34.6295 19.9442 34.6295 19.5015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.645 22.3818C34.3529 22.3818 29.2517 27.4826 29.2517 33.7751C29.2517 40.0677 34.3529 45.1685 40.645 45.1685C46.9372 45.1685 52.0383 40.0673 52.0383 33.7751C52.0383 27.483 46.9372 22.3818 40.645 22.3818ZM40.3767 33.2139H42.99V35.4272H40.4706L40.5128 36.3836C40.5128 37.0329 40.3455 37.5425 40.0108 37.9128H45.1863V40.211H36.0864V37.9128H36.9636C37.2867 37.8273 37.4571 37.5341 37.474 37.0329L37.4825 36.5803L37.4402 35.4272H36.061V33.2139H37.3721L37.3209 31.3665C37.3209 30.2032 37.6685 29.2939 38.3637 28.6384C39.0589 27.9828 39.9993 27.6552 41.1853 27.6552C42.4568 27.6552 43.4484 27.9815 44.1605 28.6339C44.8726 29.2868 45.229 30.172 45.229 31.29H42.4199C42.4199 30.399 42.034 29.9535 41.2623 29.9535C40.9726 29.9535 40.7398 30.0683 40.564 30.2984C40.3882 30.5281 40.3001 30.8841 40.3001 31.3665L40.3767 33.2139Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_234_281",
    x1: 4.36364,
    y1: 66.9091,
    x2: 55.5143,
    y2: -0.665685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058745,
    stopColor: "#633F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489578,
    stopColor: "#2A3E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1029BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinpoint);
export default __webpack_public_path__ + "static/media/icon_pinpoint.cafb4415bcfbe81d0a1f7fb028defbe7.svg";
export { ForwardRef as ReactComponent };